export default "__VITE_ASSET__DmhDQv8Z__"